// stores/dataStore.js
import { defineStore } from 'pinia'
// import callApi from "@/Javascript/callAPI";
// import {useAuth0} from "@auth0/auth0-vue"
// import PermissionsModule from "@/Javascript/PermissionsModule";

// const {apiGet} = callApi()

export const useDataStore = defineStore('dataStore', {
    state: () => ({
        quickbooksLinked: false,
    }),
    actions: {
        async fetchData() {
            // const auth = useAuth0()
            //
            // // Wait until Auth0 is done loading
            // while (auth.isLoading.value) {
            //     await new Promise(resolve => setTimeout(resolve, 50)) // wait 50ms
            // }
            //
            // try {
            //     if(auth.isAuthenticated.value && PermissionsModule.hasPermission("read:job")){
            //         const response = await apiGet('/quickbooks/linked')
            //         this.quickbooksLinked = response.data
            //     }
            //
            //     // this.quickbooksLinked = false
            // } catch (err) {
            //     console.log("Error")
            //     this.quickbooksLinked = false
            // }

            this.quickbooksLinked = true
        }
    }
})
